import { render, staticRenderFns } from "./ProjectBudgetListing.vue?vue&type=template&id=b055474a"
import script from "./ProjectBudgetListing.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetListing.vue?vue&type=script&lang=js"
import style0 from "./ProjectBudgetListing.vue?vue&type=style&index=0&id=b055474a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports